import React from "react";
import Toggle from "../../components/common/toggle";
import { useState, useEffect } from "react";
import { MdOutlineNotificationsActive } from "react-icons/md";
import { LuNotebookPen } from "react-icons/lu";

const Notification = ({ data, setData }) => {
  const [pushEnabled, setPushEnabled] = useState(true);
  const [defaultNotificationProvider, setDefaultNotificationProvider] = useState("");
  const [allowTargetedNotifications, setAllowTargetedNotifications] = useState(true);
  const [enableVersionControl, setEnableVersionControl] = useState(true);
  const [forceUpdateOnNewVersion, setForceUpdateOnNewVersion] = useState(false);

  useEffect(() => {
    if (data && data.notifications && data.notifications.defaultNotificationProvider !== undefined) {
      setPushEnabled(data.notifications?.pushEnabled ?? true);
      setDefaultNotificationProvider(String(data.notifications?.defaultNotificationProvider || ""));
      setAllowTargetedNotifications(data.notifications?.allowTargetedNotifications ?? true);
      setEnableVersionControl(data.contentVersioning?.enableVersionControl ?? true);
      setForceUpdateOnNewVersion(data.contentVersioning?.forceUpdateOnNewVersion ?? false);
    }
  }, [data?.notifications?.pushEnabled, data?.notifications?.defaultNotificationProvider, data?.notifications?.allowTargetedNotifications, data?.contentVersioning?.enableVersionControl, data?.contentVersioning?.forceUpdateOnNewVersion]);

  useEffect(() => {
    if (setData && pushEnabled !== undefined) {
      setData(prevData => ({
        ...prevData,
        notifications: {
          ...prevData.notifications,
          pushEnabled,
          defaultNotificationProvider,
          allowTargetedNotifications,
        },
        contentVersioning: {
          ...prevData.contentVersioning,
          enableVersionControl,
          forceUpdateOnNewVersion,
        }
      }));
    }
  }, [pushEnabled, defaultNotificationProvider, allowTargetedNotifications, enableVersionControl, forceUpdateOnNewVersion]);

  return (
    <>
      <div className="auth">
        <div className="authentSetting">
          <h4>
            <MdOutlineNotificationsActive /> Notification Settings
          </h4>
          <p>Control push notifications and providers</p>

          <div className="body">
            <form action="post">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div className="label">
                  <label htmlFor="">Enable Push Notifications</label>
                  <p>Send push notifications to users</p>
                </div>
                <Toggle
                  onChange={(newChecked) => setPushEnabled(newChecked)}
                  checked={pushEnabled}
                />
              </div>

              <div
                className="text-inputs"
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                <div style={{ width: "100%", marginTop: "20px" }}>
                  <label htmlFor="notificationProvider">
                    Default Notification Provider{" "}
                  </label>
                  <br />
                  <select
                    name="defaultNotificationProvider"
                    id="notificationProvider"
                    value={defaultNotificationProvider}
                    onChange={(e) => setDefaultNotificationProvider(e.target.value)}
                    style={{ width: "100%", marginTop: "10px" }}
                  >
                    <option value="">---Select Provider---</option>
                    <option value="firebase">Firebase</option>
                    <option value="onesignal">OneSignal</option>
                    <option value="pusher">Pusher</option>
                  </select>
                </div>
              </div>
<div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div className="label">
                  <label htmlFor="">Allow Targeted Notifications</label>
                  <p>Enable sending notifications to specific user groups</p>
                </div>
                <Toggle
                  onChange={(newChecked) => setAllowTargetedNotifications(newChecked)}
                  checked={allowTargetedNotifications}
                />
              </div>
              
            </form>
          </div>
        </div>

        <div className="authentSetting">
          <h4>
            <LuNotebookPen /> Content Versioning
          </h4>
          <p>Manage app version control settings</p>
          <div className="body">
            <form action="post">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div className="label">
                  <label htmlFor="">Enable Version Control</label>
                  <p>Track and manage content versions</p>
                </div>
                <Toggle
                  onChange={(newChecked) => setEnableVersionControl(newChecked)}
                  checked={enableVersionControl}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div className="label">
                  <label htmlFor="">Force Update on New Version</label>
                  <p>Require users to update to the latest version</p>
                </div>
                <Toggle
                  onChange={(newChecked) => setForceUpdateOnNewVersion(newChecked)}
                  checked={forceUpdateOnNewVersion}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Notification;    